export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.copyable.success': 'Replicated',
  'component.copyable.faild': 'Copy failed',
};
